import { atom } from "recoil";

export const notificationList = atom({
  key: "notifications",
  default: [],
});
